import React from 'react'
import boysBigPic from '../images/NP/IMG_1739.jpg'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { FaSpotify, FaItunes } from 'react-icons/fa'

const Landing = () => {
  return (
    <div className="relative h-screen">
      <Helmet>
        <title>The Non-Prophets</title>
        <meta name="description" content="Asheville, NC bluegrass band." />
        <link rel="canonical" href="/" />
        <link
          rel="icon"
          type="image/png"
          href="favicon-96x96.png"
          sizes="96x96"
        />
        <link rel="icon" type="image/svg+xml" href="favicon.svg" />
        <link rel="shortcut icon" href="favicon.ico" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="apple-touch-icon.png"
        />
        <link rel="manifest" href="site.webmanifest" />
        <meta charset="utf-8" />
        <link
          rel="icon"
          type="image/png"
          href="favicon.ico/favicon-96x96.png"
          sizes="96x96"
        />
        <link rel="icon" type="image/svg+xml" href="favicon.ico/favicon.svg" />
        <link rel="shortcut icon" href="favicon.ico/favicon.ico" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="favicon.ico/apple-touch-icon.png"
        />
        <meta name="apple-mobile-web-app-title" content="AMB" />
      </Helmet>

      {/* Background Image */}
      <img
        src={boysBigPic}
        alt="The Non-Prophets"
        className="w-full h-full object-cover "
      />

      {/* Buttons Wrapper - Top Left */}
      <div className="absolute top-4 left-4 flex flex-col items-start gap-3 z-50">
        <Link to="/home">
          <button className="rounded bg-orange-400 text-gray-700 py-2 px-4 tracking-widest hover:opacity-80 duration-500 shadow-xl">
            ENTER SITE
          </button>
        </Link>
        <a
          href="https://open.spotify.com/album/2dZnUysh8JMfyNiBg6h1C9?si=-W-Ye05RToulX0s3ArzL3g&nd=1&dlsi=837a3c4d96e24f08"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="flex items-center gap-2 rounded bg-indigo-200 text-cyan-600 font-bold py-2 px-4 tracking-widest hover:opacity-80 duration-500 shadow-xl">
            STREAM <span className="font-normal">//</span>
            <FaSpotify className="text-green-500 text-3xl" />
          </button>
        </a>

        <a
          href="https://music.apple.com/us/album/backstage-pass/6773667824"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="flex items-center gap-2 rounded bg-indigo-200 text-cyan-600 font-bold py-2 px-4 tracking-widest hover:opacity-80 duration-500 shadow-xl">
            STREAM <span className="font-normal">//</span>
            <FaItunes className="text-pink-600 text-3xl" />
          </button>
        </a>
      </div>
    </div>
  )
}

export default Landing
